import React, { useEffect } from 'react';
import styles from './App.module.scss';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Welcome from './kit/scenes/Welcome';
import SignIn from './kit/scenes/SignIn';
import SignUp from './kit/scenes/SignUp';
import Tracker from './kit/scenes/Tracker';
import AddMeal from './kit/scenes/AddMeal';
import { useAuth } from './hooks/auth';
import ForgotPassword from "./kit/scenes/ForgotPassword";
import ResetPassword from "./kit/scenes/ResetPassword";
import Header from "./kit/components/Header";

const App = () => {
  const { isAuthenticated, isLoading, user } = useAuth();

  return (
    <div className={styles.app}>
      <Router>
        <Header />
        <div className={styles.page}>
          <Switch>
            <Route path="/" exact={true}>
              <Welcome />
            </Route>
            <Route path="/signin" exact={true}>
              <SignIn />
            </Route>
            <Route path="/signup" exact={true}>
              <SignUp />
            </Route>
            <Route path="/forgot" exact={true}>
              <ForgotPassword />
            </Route>
            <Route path="/reset" exact={true}>
              <ResetPassword />
            </Route>
            {
              user && <>
                <Route path="/tracker" exact={true}>
                  <Tracker />
                </Route>
                <Route path="/tracker/:trackId/group/:groupId/meal" exact={true}>
                  <AddMeal />
                </Route>
              </>
            }
          </Switch>
        </div>
      </Router>
    </div>
  );
};

export default App;
